<span class="buttons-title">Action Buttons</span>
<div class="customization-inputs-list" [class.border]="!readonly()">
  <u-row-manager
    [editingModel]="model()"
    [model]="validModel()"
    [modelItem]="modelItem()"
    [limit]="ROWS_LIMIT"
    [rowTemplate]="inputsRowTemplate"
    [isRowValid]="checkIsRowValid"
    [addButtonText]="'Add Button'"
    [state]="readonly() ? 'readonly' : null"
    (onUpdatedRows)="onUpdatedRows($event)"
    (saveRowFailed)="setInputsErrors($event)"
  ></u-row-manager>
</div>

<ng-template #inputsRowTemplate let-row let-idxLine="index">
  @for (input of row.content; track input.text; let first = $first, idxColumn = $index) {
    <div class="customization-input-container">
      <u-input
        [class]="'input-' + input.id"
        [model]="input.input"
        [maxlength]="input.id === 'text' ? BUTTON_TEXT_CHARS_LIMIT : undefined"
        [errorBorder]="row.mode !== 'constantRow' && !!errors()[idxColumn]"
        [errorText]="row.mode !== 'constantRow' && errors()[idxColumn] ? errors()[idxColumn] : ''"
        [errorTextOnly]="!!(row.mode !== 'constantRow' && first && limitCharMessages()[idxLine]) ? limitCharMessages()[idxLine] : ''"
        (onChange)="onChangeItem($event, idxLine, idxColumn)"
        (onBlur)="onBlurItem($event, idxLine, idxColumn)"
        (onFocus)="onFocusItem($event, idxLine, idxColumn)"
        inputSize="small"
        [placeholder]="input.placeholder"
        [readonly]="readonly() || row.mode === 'constantRow'"
        [inputFocus]="row.mode !== 'constantRow' && first && focusInputs()"
        [showOverflowTooltip]="true"
        (keydown.enter)="$event.stopPropagation()"
      ></u-input>
    </div>
  }
</ng-template>
